export default {
  // START GENERATED IMPORTS
  'CoverageMap': { loader: () => import('../../../blocks/CoverageMap/script.js'), strategy: 'visible' },
  'GatedContentCard': { loader: () => import('../../../blocks/GatedContentCard/script.js'), strategy: 'visible' },
  'postGridList': { loader: () => import('../../../blocks/PostGridList/script.js'), strategy: 'visible' },
  'pegasus/returntopage': { loader: () => import('../../../blocks/ReturnToPage/script.js'), strategy: 'visible' },
  'pegasus/table': { loader: () => import('../../../blocks/Table/script.js'), strategy: 'visible' },
  'TableExplorer': { loader: () => import('../../../blocks/TableExplorer/script.js'), strategy: 'visible' },
  // END GENERATED IMPORTS
}
